import * as actionTypes from './taxBookActionType';
import { TaxBookRequest, TaxBookResponse } from 'routes/main/taxInvoice/types';

export const taxBookRequest = (payload: TaxBookRequest): actionTypes.TaxBookRequestAction => {
  return {
    type: actionTypes.TAX_BOOK_REQUEST,
    payload,
  };
};

export const taxBookSuccess = (payload: TaxBookResponse): actionTypes.TaxBookSuccessAction => {
  return {
    type: actionTypes.TAX_BOOK_SUCCESS,
    payload,
  };
};

export const taxBookError = (message: string, error?: any): actionTypes.TaxBookErrorAction => {
  return {
    type: actionTypes.TAX_BOOK_ERROR,
    payload: {
      message,
      error,
    },
  };
};

export const taxBookReset = (): actionTypes.TaxBookResetAction => {
  return {
    type: actionTypes.TAX_BOOK_RESET,
  };
};


